const EVENT = {

    //Defined types of events's sort
    NOT_ORDER: 0,
    ASC_ORDER: 1,
    DES_ORDER: 2
}

export default EVENT


// WEBPACK FOOTER //
// ./src/constants/event-constants.js